import React, { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { SnackbarContent } from '@mui/material';

function AppSnackbar({message,vertical}) {
  const [open, setOpen] = useState(false);
  

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  // 自动关闭 Snackbar
  React.useEffect(() => {
        setTimeout(()=>{
            setOpen(true);
        },2000)
  }, []);

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: vertical, horizontal: 'center' }}
        open={open}
        autoHideDuration={2000} // 3秒自动关闭
        onClose={handleClose}
        message=""
        severity="success"
      >
        <SnackbarContent
          style={{
            backgroundColor:"rgba(0, 0, 0, 0.8)",
            color:"#fff",
          }}
          message={message}
        />
      </Snackbar>
    </div>
  );
}

export default AppSnackbar;
